import { BackOfficeDtoConverter } from 'shared/services/backoffice-data-provider';

import { LeaderboardModel } from './models/Leaderboard.model';

export class LeaderboardDtoConverter extends BackOfficeDtoConverter {
  convert(dto: any) {
    return LeaderboardModel.fromDto(dto) as any;
  }
}
